/**
 * O funil da demonstração — o mesmo "Comercial" que a `0100` semeia no banco,
 * com as etapas que eram fixas até a trilha T7. Os ids são os que os leads de
 * `contatosDemo.ts` apontam.
 */

import type { Funil } from './tipos';

export const FUNIS_SEMENTE: Funil[] = [
    {
        id: 'fu-comercial', nome: 'Comercial', ordem: 0,
        etapas: [
            { id: 'et-novo', funilId: 'fu-comercial', titulo: 'Novo lead', tipo: 'aberta', ordem: 1, cor: 'neutro' },
            { id: 'et-contato', funilId: 'fu-comercial', titulo: 'Em contato', tipo: 'aberta', ordem: 2, cor: 'info' },
            { id: 'et-avaliacao', funilId: 'fu-comercial', titulo: 'Avaliação agendada', tipo: 'aberta', ordem: 3, cor: 'aviso' },
            { id: 'et-proposta', funilId: 'fu-comercial', titulo: 'Orçamento enviado', tipo: 'aberta', ordem: 4, cor: 'marca' },
            { id: 'et-ganho', funilId: 'fu-comercial', titulo: 'Ganho', tipo: 'ganho', ordem: 5, cor: 'sucesso' },
            { id: 'et-perdido', funilId: 'fu-comercial', titulo: 'Perdido', tipo: 'perdido', ordem: 6, cor: 'neutro' },
        ],
    },
];
